import { Tabs, Box, Text, Card, Flex } from "@radix-ui/themes";
import React from "react";
import GenerateView from "components/GenerateView";
import QueueView from "components/QueueView";

const CreateBaseView = () => {
  return (
    <>
      <Flex
        direction="column"
        gap="4"
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingTop: "10px",
          width: "100%",
        }}
      >
        <Card>
          <Tabs.Root defaultValue="basic">
            <Tabs.List>
              <Tabs.Trigger value="basic" style={{ cursor: "pointer" }}>
                Basic
              </Tabs.Trigger>
              {/* <Tabs.Trigger value="adv" style={{ cursor: "pointer" }}>
                Advanced
              </Tabs.Trigger> */}
            </Tabs.List>

            <Box pt="3">
              <Tabs.Content value="basic">
                <GenerateView />
              </Tabs.Content>

              {/* <Tabs.Content value="adv">
                <Text size="2">Access and update your documents.</Text>
              </Tabs.Content> */}
            </Box>
          </Tabs.Root>
        </Card>

        <QueueView />
      </Flex>
    </>
  );
};

export default CreateBaseView;
